export const NOTISTAK_ADD_QUEUE_KEY = 'examAddToQueue'
export const NOTISTAK_ASSIGN_QUEUE_KEY = 'examAssignToDoctor'
export const NOTISTAK_STALLED_EXAM_QUEUE_KEY = 'examStalledQueue'
